// utils/alerts.js
import Swal from "sweetalert2";
import SessionManager from "./sessionManager";
import RoutesMap from "../route_control/RouteControl";
import isStudent from "./isStudent";

const showTokenExpiredAlert = (message, navigate) => {
    const loginPath = isStudent() ? RoutesMap.STUDENT_LOGIN.path : RoutesMap.LOGIN.path

    // Clear session
    SessionManager.removeCookie("user_token");

    // Show popup
    Swal.fire({
        title: "Token Expired",
        text: message || "Your session has expired. Please login again.",
        icon: "error",
    }).then(() => {
        // Redirect after alert closes
        if (navigate) {
            navigate(loginPath);
        }
    });
};

export default showTokenExpiredAlert;